import { render, staticRenderFns } from "./AgentHeader.vue?vue&type=template&id=faf9ff5c&scoped=true&"
import script from "./AgentHeader.vue?vue&type=script&lang=js&"
export * from "./AgentHeader.vue?vue&type=script&lang=js&"
import style0 from "./AgentHeader.vue?vue&type=style&index=0&id=faf9ff5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf9ff5c",
  null
  
)

export default component.exports